import { CustomerModel } from 'src/app/model/CustomerModel';
import { Component, OnInit } from '@angular/core';
import { UserDetailResult, Product } from 'src/app/model/UserDetail';
import { UserModel } from 'src/app/model/UserModel';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/services/shared.service';
import { AccountService } from 'src/app/services/account.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { environment } from 'src/environments/environment';
import { CyberPaySetTransactionRequest, CyberPayLogModel } from 'src/app/model/CyberPay';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';

@Component({
  selector: 'app-fundwallet',
  templateUrl: './fundwallet.component.html',
  styleUrls: ['./fundwallet.component.css']
})
export class FundwalletComponent implements OnInit {

  processing: boolean = false;
  tranSuccess: boolean = false;
  tranFailed: boolean = false;
  userdetail: UserDetailResult;
  customerBalance: number;
  mdn: string;
  i_account: number;
  i_customer: number;
  amount: number;
  currentProduct: Product;
  remainingAmount: string;
  paymentMethod: string;
  currentUser : UserModel;
  customer : CustomerModel;
  
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private toastr: ToastrService, 
    private sharedService: SharedService, private accountService: AccountService, private paymentService: PaymentService,
    private authenticationService: AuthenticationService) {
    debugger;

     }

  ngOnInit() {
    this.currentUser = this.authenticationService.getCurrentUser();
    if(this.currentUser.i_Account != "0"){
      this.toastr.error("Not available for individual accounts");
      this.router.navigateByUrl('/dashboard');
    return;

    }

    this.getCustomer(parseInt(this.currentUser.i_Customer));
    debugger;

  }

  setSelectedPaymentMethod(option: string) {
    if (this.amount > 0) {
      if (option) {
        this.paymentMethod = option;
        return;
      }
    }

    this.toastr.error("Invalid amount", "Error");

  }

  getCustomer(i_customer : number){
    this.accountService.getCustomer(i_customer).subscribe(res=>{
      if(res.Status != 1){
        this.toastr.error("Error getting customer details", "Error");
        return;
      }

      this.customer = res.Result;
      debugger;
    });
  }


  Proceed() {
    
    debugger;
    
    if(this.amount >= 500){
      if (this.paymentMethod == "cyberpay") {
        this.gotoCyberPay();
      }
      return;
    }
    
    this.toastr.error("Invalid amount", "Error");
    return;
  }

  async gotoCyberPay() {

    try{
      
      this.processing = true;
      let customer = this.customer;
  
      if (customer == undefined) {
        this.processing = false;
        this.toastr.error(environment.GenericErrorMsg, "Error");
        return;
      }
  
  
      let cyberpayReq: CyberPaySetTransactionRequest = {} as CyberPaySetTransactionRequest;
      cyberpayReq.Currency = "NGN";
      cyberpayReq.Amount = this.amount * 100;
      cyberpayReq.CustomerEmail = this.customer.EmailAddress;
      cyberpayReq.CustomerId = this.customer.i_customer.toString();
      cyberpayReq.CustomerMobile = this.customer.MobilePhone;
      cyberpayReq.CustomerName = `${this.customer.FirstName} ${this.customer.LastName}`;
      cyberpayReq.Description = "Top up wallet " + this.customer.i_customer;
      cyberpayReq.IntegrationKey =customer.CustomerClass.Name==='Enterprise'?environment.enterpriseIntegrationKey : environment.IntegrationKey; environment.IntegrationKey;
      cyberpayReq.MerchantRef = new Date().getTime().toString();
      cyberpayReq.ProductCode = "";
      cyberpayReq.ReturnUrl = environment.CyberPayReturnURL;
      cyberpayReq.WebhookUrl = environment.webhookUrl;
  
      let res = await this.paymentService.cyberPaySetTransaction(cyberpayReq).toPromise();
      
      if (!res.succeeded) {
        this.processing = false;
        this.toastr.error("An error occured trying to set transaction, try again", "Error");
        return;
      }
  
      let cyberPayLogModel: CyberPayLogModel = {} as CyberPayLogModel;
      cyberPayLogModel.PortalCode = environment.PortalCode;
      cyberPayLogModel.CustomerID = customer.i_customer;
      cyberPayLogModel.DateCreated = new Date().toISOString();
      cyberPayLogModel.CustomerDesc = "CustomerDesc";
      cyberPayLogModel.Email = cyberpayReq.CustomerEmail;
  
      cyberPayLogModel.FullName = customer.FirstName + " " + customer.LastName;
  
      cyberPayLogModel.ItemCode = "0";
      cyberPayLogModel.ItemName = "Balance Topup";
  
      let session = `Customer-${customer.i_customer}-${this.currentUser.UserID}*${new Date().getTime().toString()}`;
      cyberPayLogModel.PhoneNumber = cyberpayReq.CustomerMobile;
      cyberPayLogModel.OperatorID = environment.OperatorID;
      cyberPayLogModel.RedirectLink = res.data.redirectUrl;
      cyberPayLogModel.Request_Payload = JSON.stringify(cyberpayReq);
      cyberPayLogModel.Session = session;
      cyberPayLogModel.TransRef = res.data.transactionReference;
      cyberPayLogModel.Transaction_status = "PENDING";
      cyberPayLogModel.Value = this.amount;
      cyberPayLogModel.amount = this.amount;
      cyberPayLogModel.i_account = 0;
      cyberPayLogModel.i_customer = customer.i_customer;
      cyberPayLogModel.i_product = 0;
      cyberPayLogModel.provider_id = environment.OperatorID;
  
  
      await this.paymentService.LteHttpLogCyberPayRequest(cyberPayLogModel).toPromise();
      window.location.href = res.data.redirectUrl;
    }
    catch(err){
      this.processing = false;
      this.tranFailed = true;
    }
    

  }


}
